import React from 'react';
import Projects from './projects';

const Project = () => {
  return (
    <section className="project section" id='project'>
        <h2 className="section_title">Project</h2>
        <span className="section_subtitle"></span>
        <div className="container">
          <Projects/>
        </div>
    </section>
  )
}

export default Project;